export default class ResultadoConsultaSolicitud{
    

    constructor() {
        this.Solicitudes = [];
        this.Mensaje="";
        this.Errores =[];
        this.EsValido =false;
    }
    
    Solicitudes : any;
    Mensaje: string;
    Errores : any[];
    EsValido : boolean;
}

